import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryIcon } from '@/shared/assets/icons/error-boundary-icon';
import { ContentContainer } from '@/shared/components/layouts/content-layout/content-layout.styled';
import { TErrorBoundaryProps } from '@/shared/features/error/components/error-boundary/error-boundary.types';
import { ErrorContainer } from '@/shared/features/error/error.styled';

export const ErrorBoundary: React.FC<TErrorBoundaryProps> = ({
  icon,
  title,
  message,
}) => {
  const { t } = useTranslation();

  const renderMessage = () => {
    if (message && typeof message !== 'string') {
      return message;
    }

    return (
      <Typography variant="p8" textAlign="center" color="textSecondary">
        {message ?? t('error:requested_resource_not_found')}
      </Typography>
    );
  };

  return (
    <ContentContainer
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <ErrorContainer
        gap="1.5rem"
        alignItems="center"
        justifyContent="space-between"
      >
        {icon ?? <ErrorBoundaryIcon variant="primary" />}
        <Typography variant="h2" textAlign="center">
          {title ?? t('error:something_went_wrong')}
        </Typography>
        {renderMessage()}
      </ErrorContainer>
    </ContentContainer>
  );
};
